import { Link } from "react-router-dom";
import { PageHero } from "@/components/site/PageHero";
import { SectionHeading } from "@/components/site/SectionHeading";
import { Reveal } from "@/components/site/Reveal";
import { CtaBand } from "@/components/site/CtaBand";
import { Icon } from "@/components/site/Icon";
import { INDUSTRIES, IMAGES } from "@/data/content";

const Industries = () => {
  return (
    <>
      <PageHero
        eyebrow="Industries & Products"
        title="Industries & Products We Deal In"
        subtitle="Serving diverse industries through reliable global sourcing and trade partnerships."
        image={IMAGES.warehouse}
      />

      <section className="bg-white py-24 lg:py-32" data-testid="industries-grid">
        <div className="container-x">
          <SectionHeading
            align="center"
            eyebrow="Sector Coverage"
            title="Broad expertise across key industries"
            subtitle="One dependable partner for sourcing, inspection and delivery across the sectors below."
          />

          <div className="mx-auto mt-14 grid max-w-5xl gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind.slug} delay={(i % 3) * 0.07}>
                <Link
                  to="/contact"
                  className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-[#fafafa] p-6 transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg"
                  data-testid={`industry-card-${ind.slug}`}
                >
                  <div className="flex items-center gap-4">
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[color:var(--brand-blue)]/10 text-[color:var(--brand-blue)] transition-colors duration-300 group-hover:bg-[color:var(--brand-blue)] group-hover:text-white">
                      <Icon name={ind.icon} className="h-6 w-6" />
                    </div>
                    <h3 className="text-base font-bold leading-snug text-slate-950">{ind.name}</h3>
                  </div>
                  {ind.products && (
                    <div className="mt-5 border-t border-slate-200 pt-4">
                      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Products</p>
                      <div className="mt-3 flex flex-wrap gap-2">
                        {ind.products.map((p) => (
                          <span key={p} className="rounded-full border border-[color:var(--brand-blue)]/20 bg-white px-3 py-1 text-xs font-medium text-[color:var(--brand-blue)]" data-testid={`product-${ind.slug}-${p.toLowerCase().replace(/[^a-z]+/g, '-')}`}>
                            {p}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </>
  );
};

export default Industries;
